
import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { TAGS_QUERY } from '../../queries/TAGS_QUERY';

export function useTagsQuery( ) {
    const { data, loading, error } = useQuery( TAGS_QUERY );

    function getTags( ids ) {
        if ( data && !loading && !error && ids ) {
            return ids.map( tagId => data.tags.edges.find( t => t.node.id === tagId )?.node.name );
        }
        return [];
    }

    return useMemo ( () => {

        const refinedData = data?.tags.edges.map( t => t.node ) ?? [];
        return {
            error: ( error ),
            loading: ( loading ),
            data: refinedData,
            getTags,
        };
    }, [ error, loading ] );
}
